import rison from 'rison';

import {api} from './Api';
import {Report, ApiParams, ISort} from '../models';
import {getRequestParams} from '../utils/api';
import {ExecuteReportOptions} from '../store/actions/reportResultActions';

export const getReport = (uid: string) => {
  return api.get(`report/${uid}`).then((res: any) => res.data);
}

export const getReports = (params: ApiParams | undefined, sort: ISort | undefined) => {
  const requestParams = getRequestParams(params, sort);

  return api.get(`report/?q=${rison.encode(requestParams)}`).then((res: any) => res.data);
}

export const createReport = (report: Partial<Report>) => {
  return api.post(`report/`, report).then((res: any) => res.data);
}

export const updateReport = (uid: string, report: Partial<Report>) => {
  return api.put(`report/${uid}`, report).then((res: any) => res.data);
}

export const updateReports = (reports: Partial<Report>[]) => {
  return api.put(`report/bulk/update`, reports).then((res: any) => res.data);
}

export const deleteReport = (uid: string) => {
  return api.delete(`report/${uid}`).then((res: any) => res.data);
}

export const deleteReports = (selected: string[]) => {
  const payload = {
    data: {ids: selected},
  };

  return api.delete(`report/bulk/delete`, payload).then((res: any) => res.data);
}

export const duplicateReport = (uid: string) => {
  return api.post(`report/${uid}/duplicate`).then((res: any) => {
    const { result } = res.data;
    return getReport(result.uid);
  });
};

export const executeReport = (uid: string, options?: ExecuteReportOptions) => {
  const payload: any = {};

  if (options) {
    payload.options = options;
  }

  return api.post(`report/${uid}/run/noteflow`, payload).then((res: any) => res.data);
}

export const reRunReport = (
  uid: string,
  flowRunId: string,
  taskRunIds: string[],
  parentTaskRunId: null | string = null
) => {
  const payload: any = {
    task_run_ids: taskRunIds,
    parent_task_run_id: parentTaskRunId,
  };

  return api.post(`/report/${uid}/re_run/noteflow/${flowRunId}`, payload).then((res: any) => res.data);
}

export const getReportSharingSettings = (uid: string) => {
  return api.get(`/report/${uid}/sharing_settings`).then((res: any) => res.data);
}

export const shareReportWithUser = (uid: string, userUid: string, permission: string) => {
  const payload: any = {
    user_uid: userUid,
    permission
  };

  return api.post(`/report/${uid}/share_with_user`, payload).then((res: any) => res.data);
};

export const shareReportWithGroup = (uid: string, groupUid: string, permission: string) => {
  const payload: any = {
    group_uid: groupUid,
    permission
  };

  return api.post(`/report/${uid}/share_with_group`, payload).then((res: any) => res.data);
};

export const shareReportWithWorkspace = (uid: string, permission: string) => {
  const payload = {
    permission
  };

  return api.post(`/report/${uid}/share_with_workspace`, payload).then((res: any) => res.data);
};
